import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import AchievementsSlide from './achievementsSlide';
import 'common/css/master.css'
import { savePtmSettingSvc, getTchRoomListSvc } from './displayPlanSvc';
import TchRoomsSlide from './tchRoomsSlide';

const DisplayPlanListTable = (props) => {
    const DISPLAY_PLAN = { WELCOME_SLIDE: 10, TOPPER_SLIDE: 20, SUB_TCH_ROOM_SLIDE: 30, ACHVMT_SLIDE: 40, GALLERY_SLIDE: 50 }
    const [id, setId] = useState(0)
    const [state, setState] = useState({ loader: 'none' });
    const [lstSlide, setLstSlide] = useState([]);
    const [vLstSlide, setVLstSlide] = useState([]);
    const [found, setFound] = useState([])
    const [sliderKey, setSliderKey] = useState(0)
    const [flgSlider, setFlgSlider] = useState(0)
    const [ptmId, setPtmId] = useState(0);
    const [lstPtmRoom, setLstPtmRoom] = useState([])
    const [keyPtmRoom, setKeyPtmRoom] = useState(0)

    useEffect(() => {
        // console.log(props.lstPtmSetting)
        // console.log("ptmId passed to DisplayPlanListTable", props.ptmId);
        setVLstSlide(props.lstPtmSetting)
        setFound(props.lstPtmSetting)
        setPtmId(props.ptmId);
    }, [props])

    const colgrp = (
        <colgroup>
            <col width='40' />
            <col width='40' />
            <col width='20' />
            <col width='40' />
        </colgroup>
    )

    const updateFlgInUse = async (pIdx, newFlgInUse) => {
        let lLstSlide = vLstSlide
        lLstSlide[pIdx].inUse = newFlgInUse;
        await setVLstSlide(lLstSlide)
    };

    const updateWaitTm = async (pIdx, newWaitTm) => {
        let lLstSlide = vLstSlide
        lLstSlide[pIdx].waitTime = newWaitTm;
        await setVLstSlide(lLstSlide)
    };

    async function openSlider(pFlgSlider, slideId) {
        // console.log(pPtmId)
        var lRandNo = Math.floor(Math.random() * 999999)
        setSliderKey(lRandNo);
        await setId(slideId)
        setFlgSlider(pFlgSlider)
    }

    function closeSlider() {
        setFlgSlider(0)
    }

    const clickItem = (slideId) => {
        // console.log("clickItem called, slideId", slideId);
        if (slideId == 1) {
            openSlider(DISPLAY_PLAN.WELCOME_SLIDE, slideId)
        } else if (slideId == 2) {
            // console.log("open toppers page");
            const newPageUrl = "/ptmToppers?ptmId=" + ptmId;
            window.open(newPageUrl, '_blank');
        } else if (slideId == 3) {
            openSlider(DISPLAY_PLAN.SUB_TCH_ROOM_SLIDE, slideId)
            getTchRoomList()
        } else if (slideId == 4) {
            openSlider(DISPLAY_PLAN.ACHVMT_SLIDE, slideId)
        } else if (slideId == 5) {
            // console.log("open gallery page");
            const newPageUrl = "/ptmGallery?ptmId=" + ptmId;
            window.open(newPageUrl, '_blank');
        } else {
            openSlider(DISPLAY_PLAN.GALLERY_SLIDE, slideId)
        }
    }

    const getTchRoomList = () => {
        getTchRoomListSvc(cbTchRoom)
    }

    const cbTchRoom = async (data) => {
        if (data.status == "Success") {
            await setLstPtmRoom(data.lstPtmRoom)
            await setKeyPtmRoom(Math.round(Math.random() * 99999))
        } else {
            toast.error(data.message)
        }
    }

    const saveSlide = () => {
        // console.log(vLstSlide)
        savePtmSettingSvc(vLstSlide, cbSaveSetting)
    }

    const cbSaveSetting = (data) => {
        if (data.status == "Success") {
            toast.success(data.message);
        } else {
            toast.error(data.message)
        }
    }
    return (
        <div>
            <div className=''>
                <ToastContainer autoClose={3000} hideProgressBar />
                <div
                    style={{
                        position: 'fixed',
                        zIndex: 10000,
                        width: 100,
                        height: 100,
                        marginLeft: -50,
                        marginTop: -50,
                        left: '50%',
                        top: '50%',
                        display: state.loader
                    }}
                >
                    <img
                        className='loderImg'
                        src={require('common/images/loader.gif')}
                        alt='Loader...'
                    />
                </div>

                <div className='col-sm-11'>
                    <table className='tableLayout1'>
                        {colgrp}
                        <thead>
                            <tr>
                                <th className='padding-remove'>
                                    Screen Display Slides
                                </th>
                                <th className='padding-remove'>
                                    Display
                                </th>
                                <th className='text-center'>Wait Time</th>
                                <th className='text-center'>Action</th>
                            </tr>
                        </thead>
                    </table>
                    <div className='tablebodyWrapper'>
                        <table className='tableLayout'>
                            {colgrp}
                            <tbody>
                                {vLstSlide.map((obj, idx) => {
                                    return (
                                        <tr
                                            key={idx}
                                            id={idx}
                                            obj={JSON.stringify(obj)}
                                            className={
                                                obj.slideId === id ? 'selected' : ''
                                            }
                                            onClick={async e => {
                                                // console.log(vLstStudent[idx])
                                                setId(obj.slideId);
                                            }}
                                        >
                                            <td className='text-left'>{obj.slide}</td>
                                            <td className='text-center'>
                                                <input
                                                    type='checkbox'
                                                    className='text-center '
                                                    defaultChecked={vLstSlide[idx]?.inUse}
                                                    // id={`custom-checkbox-${obj.studentId}`}
                                                    onChange={e => updateFlgInUse(idx, e.target.checked)}
                                                />
                                            </td>
                                            <td className='text-center'>
                                                <input
                                                    key={obj.slideId}
                                                    type='text'
                                                    className='form-control text-right'
                                                    // id={`custom-remarks-${obj.studentId}`}
                                                    defaultValue={vLstSlide[idx]?.waitTime}
                                                    onChange={e => updateWaitTm(idx, e.target.value)}
                                                />
                                            </td>
                                            <td className='text-center'>
                                                {obj.slide !== "Welcome" && <span
                                                    className='glyphicon glyphicon-edit'
                                                    title='Edit'
                                                    onClick={(e) => clickItem(obj.slideId)}
                                                ></span>}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-12" style={{ marginTop: 10 }}>
                    <div className="col-sm-6 pull-right" >
                        <button type="button" title="Save"
                            className="btn btn-info" onClick={() => saveSlide()}>Save</button>
                    </div>
                </div>
            </div>
            <div style={{ display: flgSlider == 40 ? 'block' : 'none', width: '80%' }} className='SlotSlider'>
                <button
                    type='button'
                    className='btn btn-info text-center btnCloseDiv'
                    onClick={e => closeSlider()}
                    style={{ right: '81%' }}
                >
                    <span
                        id='close'
                        title='Close Slider'
                        className='glyphicon glyphicon-remove'
                    ></span>
                </button>

                <div
                    className='col-sm-12'
                    style={{
                        pointerEvents: state.loader === 'none' ? 'auto' : 'none',
                        height: '100%',
                        margin: '0 auto',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: 10,
                        padding: 15
                    }}
                >
                    <AchievementsSlide
                        sliderKey={sliderKey}
                        key={'s_' + id}
                        slideId={id}
                        ptmId={ptmId}
                        flgSlider={flgSlider}
                    />
                </div>
            </div>

            <div style={{ display: flgSlider == 30 ? 'block' : 'none', width: '50%' }} className='SlotSlider'>
                <button
                    type='button'
                    className='btn btn-info text-center btnCloseDiv'
                    onClick={e => closeSlider()}
                    style={{ right: '51%' }}
                >
                    <span
                        id='close'
                        title='Close Slider'
                        className='glyphicon glyphicon-remove'
                    ></span>
                </button>

                <div
                    className='col-sm-12'
                    style={{
                        pointerEvents: state.loader === 'none' ? 'auto' : 'none',
                        height: '100%',
                        margin: '0 auto',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: 10,
                        padding: 15
                    }}
                >
                    <TchRoomsSlide
                        key={keyPtmRoom}
                        slideId={id}
                        flgSlider={flgSlider}
                        getTchRoomList={getTchRoomList}
                        lstPtmRoom={lstPtmRoom}
                    />
                </div>
            </div>
        </div>
    )
}

export default DisplayPlanListTable